var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _vm.showMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.msg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMsg()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showMsgSuccess
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-success alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.msgSuccess) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMsg()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm.user
              ? _c("div", { staticClass: "col-md-12" }, [
                  _c("h1", [
                    _vm._v("Bem vindo, " + _vm._s(_vm.userFirstname) + "!")
                  ]),
                  _vm._v(" "),
                  _vm.user.profile == "ong"
                    ? _c("h4", [
                        _vm._v(
                          "Deseja cadastrar sua Organização Social? Criar um evento solidário? Acesse as opções abaixo:"
                        )
                      ])
                    : _c("h4", [
                        _vm._v(
                          "Deseja fazer uma doação? Acesse as opções abaixo:"
                        )
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "menu" }, [
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _vm.user.profile != "ong"
                            ? _c(
                                "router-link",
                                { attrs: { to: "/projects" } },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: ["fas", "dollar-sign"],
                                      size: "lg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Fazer uma Doação")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _vm.user.profile == "ong"
                            ? _c(
                                "router-link",
                                { attrs: { to: "/create-project" } },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: ["far", "envelope"],
                                      size: "lg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Cadastrar sua ONG")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _vm.user.isAdmin
                            ? _c(
                                "router-link",
                                { attrs: { to: "/create-project/event" } },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "gift"], size: "lg" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Convite do Bem")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/profile" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["far", "user"], size: "lg" }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Editar seu Perfil")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/descontosdobem" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: ["fas", "hand-holding-usd"],
                                  size: "lg"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Descontos do Bem")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.user.isPartner && _vm.user.profile == "ong"
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/profile?tab=campaigns" } },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: ["fas", "shopping-cart"],
                                      size: "lg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Criar Campanha")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _vm.user.profile != "ong"
                            ? _c(
                                "router-link",
                                { attrs: { to: "/profile/my-donations" } },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: ["fas", "chart-line"],
                                      size: "lg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Extrato Social")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading
        ? _c("Loading", {
            attrs: { message: "Aguarde, preparando a sua Dashboard..." }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aae30ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30ed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 